import React, { useState, useEffect } from 'react';
import { APIS } from '../../../../utils/api-factory';
import moment from 'moment';
import { HotTable } from "@handsontable/react";
import Handsontable from "handsontable";
import "handsontable/dist/handsontable.full.min.css";
import 'handsontable/dist/handsontable.full.css';
import * as XLSX from "xlsx";
import { DownloadLoanDisbursmentReportByDate, DownloadLoanInterestRebateReportByDate } from '../AdminActionCreator.component';
import Loader from '../../../presentationals/Loader/Loader.component'
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';

const GetHeadingNameFn = (name) => {
    if (name === "loanDisbursedReport") {
        return "Disbursement Report"
    } else if (name === "loanInterestRebateReport") {
        return "Rebate Analysis"
    }
}

export default function DisbursedRebateReport({ pageViewState, admin }) {
    const dispatch = useDispatch();
    const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
    const [loader, setLoader] = useState(false)
    const [payload, setPayload] = useState({
        from: fromDate,
        to: toDate
    })
    const [excelData, setExcelData] = useState("")

    useEffect(() => {
        setPayload({
            from: fromDate,
            to: toDate
        })
        {
            pageViewState === "loanDisbursedReport" ?
                GetLoanDisbursmentReportByDateAPI(fromDate, toDate)
                : pageViewState === "loanInterestRebateReport" ?
                    GetInterestRebateReportByDateAPI(fromDate, toDate)
                    : ''
        }


    }, [fromDate, toDate]);

    const handleDate = (e, type) => {
        if (type === "from") {
            dispatch({ type: FILTER_ACTION, payload: { fromDate: e.target.value } });
            setPayload((prev) => ({
                ...prev,
                [type]: e.target.value
            }))
        }
        else if (type === "to") {
            dispatch({ type: FILTER_ACTION, payload: { toDate: e.target.value } });
            setPayload((prev) => ({
                ...prev,
                [type]: e.target.value
            }))
        }
    }

    const applyFilter = () => {
        {
            pageViewState === "loanDisbursedReport" ?
                GetLoanDisbursmentReportByDateAPI(payload.from, payload.to)
                : pageViewState === "loanInterestRebateReport" ?
                    GetInterestRebateReportByDateAPI(payload.from, payload.to)
                    : ''
        }
    }

    useEffect(() => {
        {
            pageViewState === "loanDisbursedReport" ?
                GetLoanDisbursmentReportByDateAPI(payload.from, payload.to)
                : pageViewState === "loanInterestRebateReport" ?
                    GetInterestRebateReportByDateAPI(payload.from, payload.to)
                    : ''
        }

    }, [pageViewState])

    const GetLoanDisbursmentReportByDateAPI = (from, to) => {
        setLoader(true)
        const start = moment(from).format("DD-MM-YYYY")
        const end = moment(to).format("DD-MM-YYYY")
        fetch(APIS.GET_LOAN_DISBURSMENT_REPORT + start + "&eDate=" + end)
            .then(res => res.blob())
            .then(res => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: "array" });
                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];
                    const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                    setExcelData(jsonData);
                };
                reader.readAsArrayBuffer(res);
                setLoader(false)
            })
            .catch(e => {
                setLoader(false)
            })

    }

    const GetInterestRebateReportByDateAPI = (from, to) => {
        setLoader(true)
        const start = moment(from).format("DD-MM-YYYY")
        const end = moment(to).format("DD-MM-YYYY")
        fetch(APIS.GET_INTEREST_REBATE_REPORT + start + "&eDate=" + end)
            .then(res => res.blob())
            .then(res => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: "array" });
                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];
                    const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                    setExcelData(jsonData);
                };
                reader.readAsArrayBuffer(res);
                setLoader(false)
            })
            .catch(e => {
                setLoader(false)
            })

    }

    const DownloadDisbursmentReportData = (from, to) => {
        const start = moment(from).format("DD-MM-YYYY")
        const end = moment(to).format("DD-MM-YYYY")
        setLoader(true)
        DownloadLoanDisbursmentReportByDate(start, end, callback => {
            console.log(callback)
            setLoader(false)
        })
    }

    const DownloadInterestRebateReportData = (from, to) => {
        const start = moment(from).format("DD-MM-YYYY")
        const end = moment(to).format("DD-MM-YYYY")
        setLoader(true)
        DownloadLoanInterestRebateReportByDate(start, end, callback => {
            console.log(callback)
            setLoader(false)
        })
    }

    const DownloadData = () => {
        {
            pageViewState === "loanDisbursedReport" ?
                DownloadDisbursmentReportData(payload.from, payload.to)
                : pageViewState === "loanInterestRebateReport" ?
                    DownloadInterestRebateReportData(payload.from, payload.to)
                    : ''
        }
    }

    return (
        <>
            <div className="container-fluid">
                {
                    loader ? <Loader /> : ""
                }
                <div>
                    <h3>{GetHeadingNameFn(pageViewState)}</h3>
                </div>

                <div className="row" style={{ marginTop: '30px' }}>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">Start Date</label>
                        <input type='date' className='form-control' value={payload.from} onChange={(e) => handleDate(e, "from")} />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">End Date</label>
                        <input type='date' className='form-control' value={payload.to} onChange={(e) => handleDate(e, "to")} />
                    </div>
                    <div className="col-sm-1 col-xs-12">
                        <button className='btn btn-primary' style={{ marginTop: '22px', padding: '10px' }} onClick={() => applyFilter()}>Apply Filter</button>
                    </div>
                    {excelData?.length > 0 && (
                        <div className="col-sm-2 col-xs-12">
                            <button className='btn btn-primary' style={{ marginTop: '22px', padding: '10px' }} onClick={() => DownloadData()}>Download Excel</button>
                        </div>
                    )}
                </div>
                <hr />

                {excelData?.length > 0 && (
                    <div style={{ display: 'flex', alignSelf: 'center' }}>
                        <div style={{ boxShadow: '5px 5px 5px 5px #c1c1c1', borderRadius: "8px", padding: '10px', width: '100%', maxWidth: '100%' }}>
                            <HotTable
                                data={excelData}
                                colHeaders={true}
                                rowHeaders={true}
                                readOnly={true}
                                width="100%"
                                manualColumnResize={true}
                                colWidths={150}
                                autoWrapCol={true}
                                height="400px"
                                stretchH="all"
                                licenseKey="non-commercial-and-evaluation"
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
